var map = {
	"./main/hero/hero": 5,
	"./main/hero/hero.png": 5,
	"./main/map/map": 6,
	"./main/map/map.svg": 6,
	"./main/staffing-benefits/pizza-express": 7,
	"./main/staffing-benefits/pizza-express.jpg": 7,
	"./main/staffing-benefits/team-and-stiner": 8,
	"./main/staffing-benefits/team-and-stiner.jpg": 8
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34;